<template>
  <message-list-component
    :messages="warning"
    type="warning"
    clear-mutation="clearWarnings"
    :show-delete-button="false"
    :show-icon="false"
  />
</template>

<script>
import gql from 'graphql-tag'
import MessageListComponent from '@/components-v2/flows/LIDL/MessageView/MessageListComponent.vue'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'EmailVerificationModal',
  components: { MessageListComponent },
  mixins: [slotProxy()],
  data () {
    return {
      currentCustomer: {
        emailVerified: true
      },
      warning: []
    }
  },
  apollo: {
    currentCustomer: {
      query: gql`query currentCustomerEmailVerification {
      currentCustomer {
        emailVerified
      }
    }`,
      result({ data }) {
        // TODO Rename getter...
        if (!data.currentCustomer.emailVerified && !this.$store.getters.wasModalShown('emailVerified')) {
          this.warning.push({
            type: 'warning',
            message: this.getSlotText('txtEmailVerification', 'Deine E-Mail-Adresse wurde noch nicht erfolgreich bestätigt.')
          })
          this.$store.commit('markModalShown', 'emailVerified')
        }
      }
    }
  }
}
</script>
